import React from 'react';
import styled from 'styled-components';
import Button from '../Components/Button';
import { RECEIVER_ACTIONS, SENDER_ACTIONS } from '../models/Engine';
import { PageType } from '../models/PageData';

const Wrapper = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .container {
    padding: 48px;
  }
  h1 {
    font-size: 54px;
    text-align: center;
  }
  h4 {
    font-size: 36px;
    text-align: center;
  }
  button {
    width: 100%;
    font-size: 24px;
    padding: 18px 4px;
  }
`;

const Status: React.FC = () => {
  const text = window.MESSAGE && window.MESSAGE.length > 0 ? window.MESSAGE : 'FAILED TO GET STATUS';

  return (
    <Wrapper>
      <div className="container">
        <h1>{text}</h1>
        <br />
        <Button
          onClick={() => {
            window.SENDER({ type: SENDER_ACTIONS.RESET_MACHINE, payload: '' });
            window.RECEIVER({
              type: RECEIVER_ACTIONS.CHANGE_PAGE,
              payload: { page: PageType.SCREEN_DEFAULT, message: 'RESETTING MACHINE STATUS' },
            });
          }}>
          RESET MACHINE STATUS
        </Button>
        <Button
          onClick={() =>
            window.RECEIVER({
              type: RECEIVER_ACTIONS.CHANGE_PAGE,
              payload: { page: PageType.SCREEN_ADMIN },
            })
          }>
          BACK TO ADMIN PAGE
        </Button>
      </div>
    </Wrapper>
  );
};

export default Status;
